import React from 'react';
import { PickList } from '../components/PickList';
import { useWarehouseAppContext } from '../hooks/useWarehouseAppContext';

export const PickListPage: React.FC = () => {
  const {
    selectedOrder,
    isScanning,
    scanType,
    itemRefs,
    expandedItems,
    expandedLocations,
    handleScan,
    handleItemClick,
    toggleItemExpanded,
    toggleLocationExpanded,
    openBatchSelection,
    openSerialInput,
    openQtyEdit,
    confirmStandardPick,
    openBatchQtyEdit,
    startItemScanning,
    closeScanner,
  } = useWarehouseAppContext();

  if (!selectedOrder) {
    return null;
  }

  return (
    <PickList
      order={selectedOrder}
      onScanClick={startItemScanning}
      isScanning={isScanning && scanType === 'item'}
      onScan={handleScan}
      onCloseScanner={closeScanner}
      itemRefs={itemRefs}
      expandedItems={expandedItems}
      expandedLocations={expandedLocations}
      onItemClick={handleItemClick}
      onToggleItemExpanded={toggleItemExpanded}
      onToggleLocationExpanded={toggleLocationExpanded}
      onOpenBatchModal={openBatchSelection}
      onOpenSerialModal={openSerialInput}
      onOpenQtyModal={openQtyEdit}
      onConfirmStandardPick={confirmStandardPick}
      onOpenBatchQtyEdit={openBatchQtyEdit}
    />
  );
};
